import {
    DEALERCHANGEDSRMASTERPASSWORD_SUCCESS,
    DEALERCHANGEDSRMASTERPASSWORD_FAILED,
    RESET_DEALERCHANGEDSRMASTERPASSWORD,
    LOADING_DEALERCHANGEDSRMASTERPASSWORD,
    NETWORK_ERROR_DEALERCHANGEDSRMASTERPASSWORD
} from '../types/index'
import { dealerServices } from "../../config/axios";

const resetDealerChangeDsrMasterPassword = () => {
    return { type: RESET_DEALERCHANGEDSRMASTERPASSWORD };
};

const dealerChangeDsrMasterPassword = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DEALERCHANGEDSRMASTERPASSWORD });
    await dealerServices
        .post("changeDsrMasterPassword", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(dealerChangeDsrMasterPasswordsuccess(res.data));
                    break;
                default:
                    dispatch(dealerChangeDsrMasterPasswordFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DEALERCHANGEDSRMASTERPASSWORD,
                payload: err
            });
        });
}

function dealerChangeDsrMasterPasswordsuccess(data) {
    return {
        type: DEALERCHANGEDSRMASTERPASSWORD_SUCCESS,
        payload: data
    };
}
function dealerChangeDsrMasterPasswordFailed(data) {
    return {
        type: DEALERCHANGEDSRMASTERPASSWORD_FAILED,
        payload: data
    };
}
export { resetDealerChangeDsrMasterPassword, dealerChangeDsrMasterPassword }